import { useEffect, useState } from "react";
import "../components/css/contact.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Carousel,
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Modal,
  ProgressBar,
} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import cc from "../components/images/Phone icon pbt.webp";
import lo from "../components/images/IMG (56).webp";
import ww from "../components/images/IMG (57).webp";
import ccc from "../components/images/IMG (33).webp";
import backgroundImage from "../components/images/Banner for website.jpg";
import img1 from "../components/images/Contact Us.webp";
import img2 from "../components/images/Slider 2webp.webp";
import img3 from "../components/images/Slider 3webp.webp";
import img4 from "../components/images/Slider 4webp.webp";
import img5 from "../components/images/Slider 5webp.webp";
import img6 from "../components/images/Slider 6webp.webp";
import img7 from "../components/images/Slider 1webp.webp";
import { addContsctUs, getJobPostings } from "../App/Slices/contactusSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsWhatsapp,
  BsYoutube,
} from "react-icons/bs";

const Contact = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showJobModal, setShowJobModal] = useState(false); // New state for job application modal
  const [uploadProgress, setUploadProgress] = useState(0);
  const [mobileValid, setPhoneValid] = useState(true);
  const { jobposts } = useSelector((state) => state.contactusData);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (jobposts && jobposts.length > 0) {
      setImage1(
        jobposts[0]?.image1 ? `${baseUrl}/${jobposts[0].image1}` : null,
      );
      // setImage2(jobposts[0]?.image2 ? `${baseUrl}/${jobposts[0].image2}` : null); // ✅ corrected
    }
  }, [jobposts, baseUrl]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    resume: null,
  });

  // New state for job application form
  const [jobFormData, setJobFormData] = useState({
    jobTitle: "",
    name: "",
    email: "",
    phone: "",
    message: "",
    resume: null,
  });

  const slides = [
    {
      id: 1,
      image: img1,
    },
    {
      id: 2,
      image: img2,
    },
    {
      id: 3,
      image: img3,
    },
    {
      id: 4,
      image: img4,
    },
    {
      id: 5,
      image: img5,
    },
    {
      id: 6,
      image: img6,
    },
    {
      id: 7,
      image: img7,
    },
  ];
  const handleContactModalClose = () => setShowModal(false);
  const handleContactModalShow = () => setShowModal(true);

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setUploadProgress(0);
    setPhoneValid(true);
    setFormData({
      name: "",
      email: "",
      mobile: "",
      message: "",
      resume: null,
    });
  };

  // New handlers for job application modal
  const handleJobModalShow = () => setShowJobModal(true);
  const handleJobModalClose = () => {
    setShowJobModal(false);
    setUploadProgress(0);
    setJobFormData({
      jobTitle: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      resume: null,
    });
  };

  useEffect(() => {
    dispatch(getJobPostings());
  }, [dispatch]);

  // 📞 Live validation for mobile input
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove non-digits
    setPhoneValid(value.length === 10);
    setFormData({ ...formData, mobile: value });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      const file = files[0];
      if (file && file.type !== "application/pdf") {
        toast.error("❌ Only PDF files are allowed.");
        return;
      }
      setFormData({ ...formData, resume: file });
    } else if (name !== "mobile") {
      setFormData({ ...formData, [name]: value });
    }
  };

  // New handler for job form changes
  const handleJobFormChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      const file = files[0];
      if (file && file.type !== "application/pdf") {
        toast.error("❌ Only PDF files are allowed.");
        return;
      }
      setJobFormData({ ...jobFormData, resume: file });
    } else {
      setJobFormData({ ...jobFormData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!mobileValid) {
      toast.error("📞 Phone number must be exactly 10 digits.");
      return;
    }

    if (!formData.name || !formData.email || !formData.resume) {
      toast.warning(
        "⚠️ Please fill all required fields and upload a PDF resume.",
      );
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("mobile", formData.mobile);
    data.append("message", formData.message);
    data.append("resume", formData.resume);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "http://localhost/pbt/apply-job.php");

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setUploadProgress(percent);
      }
    };

    xhr.onload = () => {
      const result = JSON.parse(xhr.responseText);
      if (xhr.status === 200 && result.success) {
        toast.success("✅ Application submitted successfully!");
        handleClose();
      } else {
        toast.error("❌ Submission failed.");
      }
    };

    xhr.onerror = () => {
      toast.error("❌ Upload failed. Try again.");
    };

    xhr.send(data);
  };

  // New handler for job application form submission
  // const handleJobFormSubmit = (e) => {
  //   e.preventDefault();

  //   // Validate phone number
  //   const phoneRegex = /^\d{10}$/;
  //   if (!phoneRegex.test(jobFormData.phone)) {
  //     toast.error('📞 Phone number must be exactly 10 digits.');
  //     return;
  //   }

  //   if (!jobFormData.jobTitle || !jobFormData.name || !jobFormData.email || !jobFormData.phone || !jobFormData.resume) {
  //     toast.warning('⚠️ Please fill all required fields and upload a PDF resume.');
  //     return;
  //   }

  //   const data = new FormData();
  //   data.append('jobTitle', jobFormData.jobTitle);
  //   data.append('name', jobFormData.name);
  //   data.append('email', jobFormData.email);
  //   data.append('phone', jobFormData.phone);
  //   data.append('message', jobFormData.message);
  //   data.append('resume', jobFormData.resume);

  //   const xhr = new XMLHttpRequest();
  //   xhr.open('POST', 'http://localhost/pbt/apply-job.php');

  //   xhr.upload.onprogress = (e) => {
  //     if (e.lengthComputable) {
  //       const percent = Math.round((e.loaded / e.total) * 100);
  //       setUploadProgress(percent);
  //     }
  //   };

  //   xhr.onload = () => {
  //     const result = JSON.parse(xhr.responseText);
  //     if (xhr.status === 200 && result.success) {
  //       toast.success('✅ Job application submitted successfully!');
  //       handleJobModalClose();
  //     } else {
  //       toast.error('❌ Submission failed.');
  //     }
  //   };

  //   xhr.onerror = () => {
  //     toast.error('❌ Upload failed. Try again.');
  //   };

  //   xhr.send(data);
  // };

  const handleJobFormSubmit = (e) => {
    e.preventDefault();

    // Validate phone number
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(jobFormData.phone)) {
      toast.error("📞 Phone number must be exactly 10 digits.");
      return;
    }

    if (
      !jobFormData.jobTitle ||
      !jobFormData.name ||
      !jobFormData.email ||
      !jobFormData.phone ||
      !jobFormData.resume
    ) {
      toast.warning(
        "⚠️ Please fill all required fields and upload a PDF resume.",
      );
      return;
    }

    const data = new FormData();
    data.append("jobTitle", jobFormData.jobTitle);
    data.append("name", jobFormData.name);
    data.append("email", jobFormData.email);
    data.append("phone", jobFormData.phone);
    data.append("message", jobFormData.message);
    data.append("resume", jobFormData.resume);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "http://localhost/pbt/sendemail.php"); // ✅ point to sendemail.php

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setUploadProgress(percent);
      }
    };

    xhr.onload = () => {
      try {
        const result = JSON.parse(xhr.responseText);
        if (xhr.status === 200 && result.success) {
          toast.success("✅ Job application submitted successfully!");
          handleJobModalClose();
        } else {
          toast.error("❌ Submission failed.");
        }
      } catch (err) {
        toast.error("❌ Invalid response from server.");
      }
    };

    xhr.onerror = () => {
      toast.error("❌ Upload failed. Try again.");
    };

    xhr.send(data);
  };

  const validateForm = () => {
    const { name, email, mobile } = formData;

    if (!name.trim() || !email.trim() || !mobile.trim()) {
      toast.error("Please fill in all required fields.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email.");
      return false;
    }

    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobile)) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return false;
    }

    return true;
  };

  const handleChangeform = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmitform = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await dispatch(addContsctUs(formData));

      if (response.status == "success") {
        toast.success(response.message);
        setFormData({ name: "", email: "", mobile: "", message: "" });
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error. Please try again later.");
    }
  };

  const handleNavigete = () => {
    navigate("/blogs");
  };

  return (
    <>
      <Helmet>
        <title>CONTACT US</title>
        <meta name="description" content="CONTACT US" />
        <meta property="og:title" content="CONTACT US" />
        <meta property="og:description" content="CONTACT US" />
        <meta property="og:image" content={image1} />
      </Helmet>
      <Carousel interval={3000} fade={true} pause="hover" indicators={true}>
        {slides.map((slide) => (
          <Carousel.Item key={slide.id} className="carousel-item">
            {/* Background Image */}
            <div className="carousel-images-home">
              <img
                src={slide.image}
                alt={`Slide ${slide.id}`}
                className="img-fluid w-100"
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      <section className="join-our-team-section py-5">
        <Container>
          <Row>
            {/* Job Listings Section */}
            <Col lg={6} md={12} className="mb-4">
              <Card className="job-card mb-3">
                <Card.Body>
                  <img
                    src={image1}
                    alt="post 1"
                    className="img-fluid w-100"
                    style={{ cursor: "pointer" }}
                    onClick={handleJobModalShow}
                  />
                </Card.Body>
              </Card>
            </Col>

            {/* Contact Form Section */}
            <Col lg={6} md={12}>
              <h3 className="text-centerr mb-2">CONTACT US</h3>
              <div className="clean-form-background p-4">
                <Form onSubmit={handleSubmitform}>
                  <Form.Group className="mb-3">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChangeform}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Your Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChangeform}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      placeholder="Mobile Number"
                      value={formData.mobile}
                      onChange={handleChangeform}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Your message</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      rows={4}
                      placeholder="Your message"
                      value={formData.message}
                      onChange={handleChangeform}
                    />
                  </Form.Group>
                  <Button type="submit" className="w-100">
                    Submit
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Existing Modal */}
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Apply Now</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <Modal.Body>
              <Row>
                <Col lg={6} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone *</Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handlePhoneChange}
                      isInvalid={!mobileValid}
                      maxLength={10}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid 10-digit mobile number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={3}
                  value={formData.message}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Resume (PDF only) *</Form.Label>
                <Form.Control
                  type="file"
                  name="resume"
                  accept=".pdf"
                  onChange={handleChange}
                  required
                />
                {uploadProgress > 0 && (
                  <ProgressBar
                    now={uploadProgress}
                    label={`${uploadProgress}%`}
                    className="mt-2"
                  />
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Submit Application
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* New Job Application Modal */}
        <Modal
          show={showJobModal}
          onHide={handleJobModalClose}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Apply for Job</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleJobFormSubmit} encType="multipart/form-data">
            <Modal.Body>
              <Row>
                <Col lg={6} md={6}>
                  <Form.Group className="my-3 ms-3">
                    <Form.Label>Job Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="jobTitle"
                      placeholder="Enter job title"
                      value={jobFormData.jobTitle}
                      onChange={handleJobFormChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col lg={6} md={6}>
                  <Form.Group className="my-3 me-3">
                    <Form.Label>Full Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter your full name"
                      value={jobFormData.name}
                      onChange={handleJobFormChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={6} md={6}>
                  <Form.Group className="mb-3 ms-3">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      value={jobFormData.email}
                      onChange={handleJobFormChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group className="mb-3 me-3">
                    <Form.Label>Phone *</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      placeholder="Enter 10-digit phone number"
                      value={jobFormData.phone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setJobFormData({ ...jobFormData, phone: value });
                      }}
                      maxLength={10}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3 px-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={3}
                  placeholder="Tell us why you're interested in this position"
                  value={jobFormData.message}
                  onChange={handleJobFormChange}
                />
              </Form.Group>
              <Form.Group className="mb-3 px-3">
                <Form.Label>Resume (PDF only) *</Form.Label>
                <Form.Control
                  type="file"
                  name="resume"
                  accept=".pdf"
                  onChange={handleJobFormChange}
                  required
                />
                {uploadProgress > 0 && (
                  <ProgressBar
                    now={uploadProgress}
                    label={`${uploadProgress}%`}
                    className="mt-2"
                  />
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleJobModalClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Submit Application
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      </section>

      <section className="get-in-touch-section pb-5 pt-2">
        <img
          src={ccc}
          alt="Welcome "
          className="left-side-half-circle-get-in-touch-section"
        />

        <Container fluid>
          <Row className="align-items-center">
            {/* Contact Details */}
            <Col lg={6} xs={12} md={6} className="mb-4 get-tehc-colmn-contact">
              <h2 className="text-primaryy mb-4">Get In Touch</h2>
              <p className="textparagrap1-contact">
                Connect with Panav Biotech — a trusted provider of veterinary
                vaccines, medicines, diagnostics, and nutraceuticals in India.
                Our support team is available to assist with all inquiries.
              </p>
              <ul className="list-unstyled contact-details">
                <li>
                  <div md={10} sm={10} className="p-0 flex-row flex">
                    <img src={cc} alt="" />{" "}
                    <p className="ps-2">
                      011-47563428 011-4756 3626, Customer care - 1800 572 1434
                    </p>
                  </div>
                </li>
                <li>
                  <div xs={8} className="p-0 flex-row flex">
                    <img src={ww} alt="" />
                    <p className="ps-2">
                      70, Rama Road, B-6, Najafgarh Road Industrial Area, New
                      Delhi, Delhi 110015
                    </p>
                  </div>
                </li>
                <li>
                  <div md={10} className="p-0 flex-row flex">
                    <img src={lo} alt="" />
                    <p className="ps-2">
                      Open from 10:30am - 7:00pm <br />
                      Monday to Saturday - Open <br />
                      Sunday - Closed
                    </p>
                  </div>
                </li>
              </ul>

              {/* Social Media or Additional Info can go here */}

              <div>
                <h6 className="text-[#233b77] font-semibold">Follow Us</h6>
                <div className="flex gap-2">
                  <a
                    href="https://www.facebook.com/panavbiotech/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon facebook"
                  >
                    <BsFacebook className="w-5 h-5" />
                  </a>
                  <a
                    href="https://www.instagram.com/panavbiotech/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon instagram"
                  >
                    <BsInstagram className="w-5 h-5" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/panavbiotech/posts/?feedView=all"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon linkedin"
                  >
                    <BsLinkedin className="w-5 h-5" />
                  </a>
                  <a
                    href="https://wa.me/919625404365"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon whatsapp"
                  >
                    <BsWhatsapp className="w-5 h-5" />
                  </a>
                  <a
                    href="https://youtube.com/@panavbio-tech?si=OCdvkZ5J_yA6y1z7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon youtube"
                  >
                    <BsYoutube className="w-5 h-5" />
                  </a>
                </div>
              </div>
            </Col>

            {/* Map Section */}
            <Col lg={6} xs={12} md={6}>
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4968.376156188175!2d77.1472471358349!3d28.6591783047046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03c83606edd1%3A0xb3cdc4ca04b630df!2sPanav%20Bio-Tech!5e0!3m2!1sen!2sin!4v1757927481058!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className="banner-contact-section cursor-pointer"
        onClick={handleContactModalShow}
      >
        <div className="banner-background">
          <Container fluid className="h-100">
            <Row className="h-100 align-items-center">
              <Col lg={12} md={12} className="text-end"></Col>
            </Row>
          </Container>
        </div>
      </section>
      <Modal show={showModal} onHide={handleContactModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Get In Touch</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form className="p-4" onSubmit={handleSubmitform} >
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChangeform}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Your Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChangeform}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChangeform}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Your message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                rows={4}
                placeholder="Your message"
                value={formData.message}
                onChange={handleChangeform}
              />
            </Form.Group>

            <Button type="submit" className="w-100">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Contact;
